import Alert from "@mui/material/Alert"
import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { useEffect, useState } from "react"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import ActivityReportFormFields from "../../users/activityReportFormFields"
import { adminApi } from "../axios"

export default function ViewActivityReportDialog({ open, context, onClose }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [form, setForm] = useState(null)

  useEffect(() => {
    if (!open || !context) {
      return
    }
    setLoading(true)
    setError("")
    setForm(null)
    adminApi
      .fetchActivityReportForm({
        concierge_user_id: context.concierge_user_id,
        account_owner_id: context.account_owner_id,
        report_date: context.report_date,
      })
      .then(({ data }) => {
        setForm(data?.form || null)
      })
      .catch(() => {
        setForm(null)
        setError("Unable to load report details.")
      })
      .finally(() => setLoading(false))
  }, [open, context])

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>Activity report details</DialogTitle>
      <DialogContent>
        <Column gap={2} sx={{ pt: 0.5 }}>
          {loading ? (
            <Row sx={{ justifyContent: "center", py: 4 }}>
              <CircularProgress size={28} />
            </Row>
          ) : form ? (
            <ActivityReportFormFields
              form={form}
              notes={form.notes || ""}
              notesReadOnly
              showReportDate
            />
          ) : (
            <Alert severity="error">
              {error || "No activity found for this report."}
            </Alert>
          )}
        </Column>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
